module.exports = __webpack_public_path__ + "static/img/month.e715f707.png";